const data = [
  {
    title: "Experiencia Laboral",
    dataResume: [
      {
        range: "[Julio 2022 - Febrero 2023]",
        subtitle: "SOLTELEC: Soporte | Mantenimiento | Desarrollo",
        description:
          "Soporte, mantenimiento y, desarrollo de un software aplicado en CDAs(centros de diagnostico automotriz) | Java, Git, Gitlab, Scrum, Spring boot, Linux, Mysql, Heidi, Redes.",
      },
    ],
  },
  {
    title: "Educación",
    dataResume: [
      {
        range: "[2018 - 2023]",
        subtitle: "Universidad Distrital Francisco José de Caldas",
        description: "Tecnólogo en Sistematización de Datos",
      },
    ],
  },
  {
    title: "Habilidades & Experiencias",
    dataResume: [
      {
        range: "",
        subtitle: "Java 8 | NetBeans | Heidi | MySql | Linux",
        description: `En Soltelec, formé parte de un equipo dedicado al desarrollo de software para el diagnóstico automotriz. Mis responsabilidades incluyeron solucionar problemas técnicos en pruebas de vehículos, destacando el desarrollo de una solución para medir frenos en motocarros. Utilicé Java 8, MySQL y gestioné la comunicación con puertos seriales. También proporcioné soporte a clientes, mejorando mis habilidades de atención al cliente. Utilicé herramientas como Heidi, Git y GitHub. Esta experiencia me brindó habilidades técnicas y profesionales valiosas.`,
      },
    ],
  },
  {
    title: "Certificados",
    dataResume: [
      {
        range: "[Septiembre - 2023]",
        subtitle: "Curso de React Js",
        description: "Platzi",
      },
      {
        range : "[Septiembre - 2023]",
        subtitle: "Curso de Backend con Node.js: API REST con Express.js",
        description: "Platzi"
      },
      {
        range: "[Junio - 2023]",
        subtitle: "Curso de TypeScript: Tipos Avanzados y Funciones",
        description: "Platzi",
      },
      {
        range: "[Marzo - 2023]",
        subtitle: "Curso fundamentos de TypeScript",
        description: "Platzi",
      },
      {
        range: "[Marzo - 2023]",
        subtitle: "Curso Profesional de Scrum",
        description: "Platzi",
      },
      {
        range: "[Septiembre - 2021]",
        subtitle: "Curso Practico de HTML y CSS",
        description: "Platzi",
      },
      {
        range: "[Septiembre - 2021]",
        subtitle: "Curso Práctico de React JS 2019",
        description: "Platzi",
      },
      {
        range: "[Agosto - 2021]",
        subtitle: "Curso ECMAScript 6+",
        description: "Platzi",
      },
      {
        range: "[Julio - 2021]",
        subtitle: "Curso de Fundamentos de Node.js",
        description: "Platzi",
      },
      {
        range: "[Julio - 2021]",
        subtitle: "Curso de Webpack",
        description: "Platzi",
      },
    ],
  },
];

export default data;